module.exports = __webpack_public_path__ + "static/media/icon-12.8f9ac7e0.png";